import script from "./ExamResultQuestionList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamResultQuestionList.vue?vue&type=script&setup=true&lang=ts"

import "./ExamResultQuestionList.vue?vue&type=style&index=0&id=73d3c85d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73d3c85d"]])

export default __exports__